export type PortalBannerColor =
  | 'sky'
  | 'amber'
  | 'emerald'
  | 'rose'
  | 'slate';

export const PORTAL_BANNER_COLOR_OPTIONS: Array<{
  value: PortalBannerColor;
  label: string;
  swatchClassName: string;
}> = [
  { value: 'sky', label: 'Sky', swatchClassName: 'bg-sky-600' },
  { value: 'amber', label: 'Amber', swatchClassName: 'bg-amber-500' },
  { value: 'emerald', label: 'Emerald', swatchClassName: 'bg-emerald-600' },
  { value: 'rose', label: 'Rose', swatchClassName: 'bg-rose-600' },
  { value: 'slate', label: 'Slate', swatchClassName: 'bg-slate-700' },
];

export const PORTAL_BANNER_COLOR_STYLES: Record<
  PortalBannerColor,
  { bar: string; ctaHover: string; dismissHover: string }
> = {
  sky: {
    bar: 'bg-sky-600',
    ctaHover: 'hover:text-sky-100',
    dismissHover: 'hover:bg-sky-700',
  },
  amber: {
    bar: 'bg-amber-500',
    ctaHover: 'hover:text-amber-100',
    dismissHover: 'hover:bg-amber-600',
  },
  emerald: {
    bar: 'bg-emerald-600',
    ctaHover: 'hover:text-emerald-100',
    dismissHover: 'hover:bg-emerald-700',
  },
  rose: {
    bar: 'bg-rose-600',
    ctaHover: 'hover:text-rose-100',
    dismissHover: 'hover:bg-rose-700',
  },
  slate: {
    bar: 'bg-slate-700',
    ctaHover: 'hover:text-slate-200',
    dismissHover: 'hover:bg-slate-800',
  },
};

export const resolvePortalBannerColor = (
  color: string | null | undefined,
): PortalBannerColor => {
  if (
    color === 'sky' ||
    color === 'amber' ||
    color === 'emerald' ||
    color === 'rose' ||
    color === 'slate'
  ) {
    return color;
  }
  return 'sky';
};

export interface PortalBannerActor {
  userId: string;
  name: string;
  email: string;
}

export interface PortalBanner {
  id: string;
  message: string;
  ctaLabel: string | null;
  ctaPath: string | null;
  color: PortalBannerColor;
  isActive: boolean;
  createdBy: PortalBannerActor;
  deactivatedBy: PortalBannerActor | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreatePortalBannerPayload {
  message: string;
  ctaLabel?: string;
  ctaPath?: string;
  color?: PortalBannerColor;
}
